import { render, staticRenderFns } from "./QEditVersion.vue?vue&type=template&id=5a22cc03&scoped=true&"
import script from "./QEditVersion.vue?vue&type=script&lang=js&"
export * from "./QEditVersion.vue?vue&type=script&lang=js&"
import style0 from "./QEditVersion.vue?vue&type=style&index=0&id=5a22cc03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22cc03",
  null
  
)

export default component.exports